import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { InfoIcon, Scale, Ruler } from 'lucide-react';
const weightUnits = [{
  value: 'lbs',
  label: 'lbs',
  conversion: 0.000453592
}, {
  value: 'kg',
  label: 'kg',
  conversion: 0.001
}, {
  value: 'kips',
  label: 'kips',
  conversion: 0.453592
}, {
  value: 'us-ton',
  label: 'US ton (short Ton)',
  conversion: 0.907185
}, {
  value: 'long-ton',
  label: 'Long Ton (Imperial ton)',
  conversion: 1.016047
}, {
  value: 'mt',
  label: 'mT (tonne)',
  conversion: 1
}];
const lengthUnits = [{
  value: 'ft-decimal',
  label: 'Foot (Decimal)',
  conversion: 0.3048
}, {
  value: 'inches',
  label: 'Inches',
  conversion: 0.0254
}, {
  value: 'mm',
  label: 'mm',
  conversion: 0.001
}, {
  value: 'cm',
  label: 'cm',
  conversion: 0.01
}, {
  value: 'm',
  label: 'm',
  conversion: 1
}];
export function DataInputStep({
  formData,
  setFormData
}) {
  const handleUnitChange = (value, field) => {
    const unit = field === 'weight' ? weightUnits : lengthUnits;
    const conversion = unit.find(u => u.value === value)?.conversion || 0;
    setFormData({
      ...formData,
      [`${field}Unit`]: value,
      [`${field}Conversion`]: conversion
    });
  };
  const selectedWeightUnit = weightUnits.find(u => u.value === (formData.weightUnit || 'lbs'));
  const selectedLengthUnit = lengthUnits.find(u => u.value === (formData.lengthUnit || 'ft-decimal'));
  return <div className="space-y-6" data-id="element-125">
      <div className="space-y-6" data-id="element-126">
        {/* Units Selection Row */}
        <div className="flex gap-8" data-id="element-127">
          <div className="flex-1" data-id="element-128">
            <Label className="mb-2 flex items-center gap-2" data-id="element-129">
              <Scale className="h-4 w-4" data-id="element-130" />
              Units for Weight
            </Label>
            <Select value={formData.weightUnit || 'lbs'} onValueChange={value => handleUnitChange(value, 'weight')} data-id="element-131">
              <SelectTrigger data-id="element-132">
                <SelectValue placeholder="Select unit" data-id="element-133" />
              </SelectTrigger>
              <SelectContent data-id="element-134">
                {weightUnits.map(unit => <SelectItem key={unit.value} value={unit.value} data-id="element-135">
                    {unit.label}
                  </SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div className="flex-1" data-id="element-136">
            <Label className="mb-2 flex items-center gap-2" data-id="element-137">
              <Ruler className="h-4 w-4" data-id="element-138" />
              Units for Length
            </Label>
            <Select value={formData.lengthUnit || 'ft-decimal'} onValueChange={value => handleUnitChange(value, 'length')} data-id="element-139">
              <SelectTrigger data-id="element-140">
                <SelectValue placeholder="Select unit" data-id="element-141" />
              </SelectTrigger>
              <SelectContent data-id="element-142">
                {lengthUnits.map(unit => <SelectItem key={unit.value} value={unit.value} data-id="element-143">
                    {unit.label}
                  </SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>
        {/* Conversion Preview Row */}
        <div className="grid grid-cols-2 gap-8 p-4 bg-gray-50 rounded-lg border" data-id="element-144">
          <div data-id="element-145">
            <Label className="text-sm text-gray-600" data-id="element-146">
              Weight Conversion Factor to mT
            </Label>
            <div className="text-lg font-mono" data-id="element-147">
              {selectedWeightUnit?.conversion || 0}
            </div>
          </div>
          <div data-id="element-148">
            <Label className="text-sm text-gray-600" data-id="element-149">
              Length Conversion Factor to m
            </Label>
            <div className="text-lg font-mono" data-id="element-150">
              {selectedLengthUnit?.conversion || 0}
            </div>
          </div>
        </div>
        {/* Stowage Factor Row */}
        <div className="space-y-2" data-id="element-151">
          <Label data-id="element-152">Stowage Factor</Label>
          <input type="number" value={formData.stowageFactor || '1.3'} onChange={e => setFormData({
          ...formData,
          stowageFactor: e.target.value
        })} className="w-full p-2 border rounded" step="0.1" min="1.0" data-id="element-153" />
        </div>
      </div>
      <Alert className="bg-yellow-50 border-yellow-200" data-id="element-154">
        <InfoIcon className="h-4 w-4 text-yellow-600" data-id="element-155" />
        <AlertDescription className="text-yellow-800" data-id="element-156">
          <p className="font-medium" data-id="element-157">Important Note:</p>
          <p data-id="element-158">
            A factor of 1.3 is generally recommended for project cargo on deck
            barges. For Hoppers and bigger cargo, this factor should be greater
            than 1.3 to ensure safe stowage.
          </p>
        </AlertDescription>
      </Alert>
    </div>;
}